import { Form, Row, Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import DefaultDatePicker from "../../../common/datepicker/DefaultDatePicker";

export function ContractGroup6( { state, dispatch }) {
  const { t } = useTranslation();
  const prefix = "contractSignature";
  const disabled = state.status === "COMPLETE";

  return (
    <Row>
      <Form.Group as={Col} xl={4} className="position-relative mt-4" controlId="signDate">
        <DefaultDatePicker
          id={`${prefix}-signDate`}
          name="signDate"
          label={t("Date", "Päivämäärä")}
          value={state.details.signDate ?? ""}
          onChange={(value) => dispatch({ type: "signDate", payload: value })}
          disabled={disabled}
        />
      </Form.Group>
      <Form.Group as={Col} xl={8} className="position-relative" controlId="signer">
        <Form.Label>{t("SignatorysNameEmployer", "Allekirjoittajan nimi (työnantaja)")}</Form.Label>
        <Form.Control disabled={disabled} value={state.details.signer ?? ""} onChange={(evt) => dispatch({type:"signer", payload: evt.target.value})} />
        <Form.Control.Feedback tooltip>{t("Signature", "Allekirjoitus")}</Form.Control.Feedback>
      </Form.Group>
    </Row>
  );
}
